module.exports = __webpack_public_path__ + "static/media/upload.7cc0d01c.svg";